import { FunctionComponent } from "react";
import {DictionaryType, useTranslation} from "./useTranslation";

export const Translation: FunctionComponent<{ k: string, replaceDictionary?: DictionaryType }> = ({ k, replaceDictionary }) => {
  const translation = useTranslation(k, replaceDictionary);
  return <>{translation}</>;
};
